import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-multi-lang';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Optionicon from '../../assets/Images/option.png';
import PropTypes from 'prop-types';
import { getByIdRequest, deleteRequest } from '../../redux/accessKey/accessKeyActions';
import ClientDetailmodal from './DetailsModal';
import ConfirmationModal from './Confirmation';
import ReasonModal from './ReasonModal';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import { isSuperAdmin } from '../../Components/common/utils';

const Detailsdropdown = props => {
  const {
    request_Id,
    handleLatestData,
    handleLatestDataForDelete,
    activeTab,
    updatedPermissions,
  } = props;
  const t = useTranslation();
  const nextProps = useSelector(state => ({
    selectedReqIdData: state.AccessKey.getByIdData || null,
    selectedReqIdDataRequesting: state.AccessKey.getByIdRequesting,
    deleteData: state.AccessKey.deleteData || null,
  }));
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reactivateClicked, setReactivateClicked] = useState(false);
  const [isApproveModalOpen, setApproveModalOpen] = useState(false);
  const [isRejectModalOpen, setRejectModalOpen] = useState(false);
  const [isFromEditDetails, setIsFromEditDetails] = useState(false);
  const [selectedReqModalData, setSelectedReqModalData] = useState();
  const [rejectModalData, setRejectModalData] = useState();
  const [approveModalData, setApproveModalData] = useState();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedTabListData, setSelectedTabListData] = useState({
    view_details: true,
    Edit_details: true,
    approved: true,
    reject: true,
    delete: false,
    re_activate: false,
  });

  const toggle = () => setDropdownOpen(prevState => !prevState);
  useEffect(() => {
    if (activeTab === 'approve') {
      if (updatedPermissions) {
        let a = {
          view_details:
            isSuperAdmin() || updatedPermissions.includes('view_accesskey') ? true : false,
          Edit_details:
            isSuperAdmin() || updatedPermissions.includes('add_accesskey') ? true : false,
          approved: false,
          reject: false,
          delete: isSuperAdmin() || updatedPermissions.includes('delete_accesskey') ? true : false,
          re_activate: false,
        };
        setSelectedTabListData(a);
      }
    } else if (activeTab === 'reject') {
      if (updatedPermissions) {
        let a = {
          view_details:
            isSuperAdmin() || updatedPermissions.includes('view_accesskey') ? true : false,
          Edit_details:
            isSuperAdmin() || updatedPermissions.includes('add_accesskey') ? true : false,
          approved: false,
          reject: false,
          delete: isSuperAdmin() || updatedPermissions.includes('delete_accesskey') ? true : false,
          re_activate: false,
        };
        setSelectedTabListData(a);
      }
    } else if (activeTab === 'delete') {
      if (updatedPermissions) {
        let a = {
          view_details:
            isSuperAdmin() || updatedPermissions.includes('view_accesskey') ? true : false,
          Edit_details: false,
          approved: false,
          reject: false,
          delete: false,
          re_activate: true,
        };
        setSelectedTabListData(a);
      }
    } else if (activeTab === 'new') {
      let a;
      if (updatedPermissions) {
        a = {
          view_details:
            isSuperAdmin() || updatedPermissions.includes('view_accesskey') ? true : false,
          Edit_details:
            isSuperAdmin() || updatedPermissions.includes('add_accesskey') ? true : false,
          approved: isSuperAdmin() || updatedPermissions.includes('add_accesskey') ? true : false,
          reject: isSuperAdmin() || updatedPermissions.includes('add_accesskey') ? true : false,
          delete: false,
          re_activate: false,
        };
        setSelectedTabListData(a);
      }
    }
  }, [activeTab, updatedPermissions]);

  useEffect(() => {
    if (nextProps.selectedReqIdData) {
      const {
        data: { result },
      } = nextProps.selectedReqIdData;

      if (result?.[0]) {
        setSelectedReqModalData(result[0]);
      }
    }
  }, [nextProps.selectedReqIdData]);

  useEffect(() => {
    if (nextProps.deleteData) {
      const {
        data: { result },
      } = nextProps.deleteData;
      if (result) {
        handleLatestDataForDelete();
      }
    }
  }, [nextProps.deleteData]);

  const handleViewDetailsModal = () => {
    setIsModalOpen(true);
    setIsFromEditDetails(false);
    dispatch(getByIdRequest(request_Id));
  };
  const handleEditDetailsModal = () => {
    setIsModalOpen(true);
    setIsFromEditDetails(true);
    dispatch(getByIdRequest(request_Id));
  };
  const handleModalToggle = () => {
    setIsModalOpen(false);
  };
  const handleApproved = () => {
    let data;
    data = {
      id: request_Id,
      request_status: 'approve',
    };
    setApproveModalData(data);
    setApproveModalOpen(true);
  };

  const handleReactivate = () => {
    let data;
    data = {
      id: request_Id,
      request_status: 'approve',
    };
    setApproveModalData(data);
    setApproveModalOpen(true);
    setReactivateClicked(true);
  };

  const handleReactivateModalToggle = () => {
    setReactivateClicked(false);
  };

  const handleRejected = () => {
    let data;
    data = {
      id: request_Id,
      request_status: 'reject',
      reject_response: '',
    };
    setRejectModalOpen(true);
    setRejectModalData(data);
  };

  const handleRejectModal = useCallback(value => {
    setRejectModalOpen(value);
  }, []);

  const handleDelete = () => {
    setIsDeleteModalOpen(true);
  };

  const handleDeleteConfirm = (boolean_value, value) => {
    setIsDeleteModalOpen(boolean_value);
    if (value === 'yes') {
      dispatch(deleteRequest(request_Id));
    }
  };

  const handleApprovedModalToggle = useCallback(value => {
    setApproveModalOpen(value);
  }, []);

  return (
    <>
      <Dropdown isOpen={dropdownOpen} toggle={toggle} className="dropdown-option-icon">
        <DropdownToggle>
          <img src={Optionicon} alt={'not-available'} />
        </DropdownToggle>
        <DropdownMenu className="details-dropdown-menu">
          {selectedTabListData.view_details ? (
            <DropdownItem
              className="details-dropdown-item"
              onClick={() => handleViewDetailsModal()}
            >
              {' '}
              {t('PUBLIC_API_ADMIN.VIEW_DETAILS')}
            </DropdownItem>
          ) : (
            ''
          )}
          {selectedTabListData.Edit_details ? (
            <DropdownItem
              className="details-dropdown-item"
              onClick={() => handleEditDetailsModal()}
            >
              {t('PUBLIC_API_ADMIN.EDIT_DETAILS')}
            </DropdownItem>
          ) : (
            ''
          )}
          {selectedTabListData.approved ? (
            <DropdownItem className="details-dropdown-item" onClick={() => handleApproved()}>
              {t('PUBLIC_API_ADMIN.APPROVE')}
            </DropdownItem>
          ) : (
            ''
          )}
          {selectedTabListData.reject ? (
            <DropdownItem className="details-dropdown-item" onClick={() => handleRejected()}>
              {t('PUBLIC_API_ADMIN.REJECT')}
            </DropdownItem>
          ) : (
            ''
          )}
          {selectedTabListData.delete ? (
            <DropdownItem className="details-dropdown-item" onClick={() => handleDelete()}>
              {t('PUBLIC_API_ADMIN.DELETE')}
            </DropdownItem>
          ) : (
            ''
          )}
          {selectedTabListData.re_activate ? (
            <DropdownItem className="details-dropdown-item" onClick={() => handleReactivate()}>
              {t('PUBLIC_API_ADMIN.RE_ACTIVATE')}
            </DropdownItem>
          ) : (
            ''
          )}
        </DropdownMenu>
      </Dropdown>
      {isModalOpen && (
        <ClientDetailmodal
          activeTab={activeTab}
          modalOpen={isModalOpen}
          handleModalToggle={handleModalToggle}
          req_data={selectedReqModalData}
          handleLatestData={handleLatestData}
          fromEditDetails={isFromEditDetails}
        />
      )}
      {isApproveModalOpen && (
        <ConfirmationModal
          modalData={approveModalData}
          reactivateClicked={reactivateClicked}
          handleReactivateModalToggle={handleReactivateModalToggle}
          isOpen={isApproveModalOpen}
          handleLatestData={handleLatestData}
          handleApprovedModalToggle={handleApprovedModalToggle}
        />
      )}
      {isRejectModalOpen && (
        <ReasonModal
          modalData={rejectModalData}
          isOpen={isRejectModalOpen}
          handleLatestData={handleLatestData}
          handleRejectModal={handleRejectModal}
          handleModalToggle={handleModalToggle}
        />
      )}
      {isDeleteModalOpen ? (
        <DeleteConfirmationModal
          handleDeleteConfirm={handleDeleteConfirm}
          isDeleteModalOpen={isDeleteModalOpen}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default Detailsdropdown;
Detailsdropdown.propTypes = {
  request_Id: PropTypes.string,
  key: PropTypes.string,
  handleLatestData: PropTypes.func,
  selectedPageTab: PropTypes.string,
  handleLatestDataForDelete: PropTypes.func,
  activeTab: PropTypes.string,
};
